import { isEmpty } from "lodash";
import React from "react";
import styled, { css } from "styled-components";
import { DesktopMenuContext } from "../../../contexts/VerticalDesktopMenu";
import { Helpers } from "../../../utils";
import Icon from "../../Icon";
import { Types } from '../../../types';
import { ReactSVG } from 'react-svg';
import MegamenuRight from './MegamenuRight';
import useEventBus from '../../../hooks/useEventBus';
import { CSSTransition } from 'react-transition-group';

const Megamenu = () => {

	const { active, config, theme, items, handleSelect, handleReset, verticalNavRef } = React.useContext(DesktopMenuContext);
	
	const [submenuItems, setSubmenuItems] = React.useState([]);
	const [isOpened, setIsOpened] = React.useState(false);
	
	React.useEffect(() => {
		const newItems = items.find((item: any) => item.id === active)?.items;
		// This code is piece of shit.
		// Fuck you, React.
		// Go fuck yourself.
		// You are a piece of shit.
		if ( ! active || isEmpty(newItems) ) {
			setIsOpened(false);
		} else {
			setIsOpened(true);	
			setSubmenuItems(newItems);
		}
		
	}, [active, items]);
	
	console.log(submenuItems);

	return (<>
		<CSSTransition timeout={250} in={isOpened} unmountOnExit mountOnEnter appear={active && !isEmpty(submenuItems)}>
			<VerticalNavigationWrapper submenuOpened={active}>
				<MegamenuRight {...{ config, theme }} items={submenuItems} />
			</VerticalNavigationWrapper>
		</CSSTransition>
	</>);
}

export default Megamenu;

const MenuItem = ({ config, theme, isCategoryMenu, openByDefault, position, isActive, onSelect, ...item }: any) => {
	return (
		<StyledMenuItem {...{ config, theme }} onMouseOver={onSelect} className={isActive ? 'active' : ''}>
			<StyledMenuItemLink href={item.permalink} {...{ config, theme }} >
				<StyledMenuItemLabel>
					{!isEmpty(item?.icon) && <ReactSVG src={item?.icon} />}
					<span>
						{item.label}
					</span>
				</StyledMenuItemLabel>
				{!isEmpty(item?.items) && <Icon id={'angleRight'} type="outlined" size={0.75} {...{ config }} />}
			</StyledMenuItemLink>
		</StyledMenuItem>
	)
}

const VerticalNavigationWrapper = styled.div<any>(({ config, theme, submenuOpened }) => css`
	display: flex;
	padding: 0;
	margin: 0;
	width: fit-content;
	
	position: absolute;
	top: 3em;
	
	&.enter {
			transition: all 250ms ease-in-out;
			opacity: 0;
		&-active {
			transition: all 250ms ease-in-out;
			opacity: 1;
		}
		&-done {
			opacity: 1;
		}
	}
	&.exit {
		transition: all 250ms ease-in-out;
		&-active {
			transition: all 250ms ease-in-out;
			opacity: 0;
		}
		&-done {
			opacity: 0;
		}
	}

`);

const StyledMenuItems = styled.ul<any>(({ config, theme }) => css`
	display: flex;
    flex-direction: column;
	list-style: none;
	padding: 0;
	margin: 0;
    //padding: 0 0.5em;
    color: #2B2D59; // verticalNavigationBar.background;
`);

const StyledMenuItem = styled.li<any>(({ isCategoryMenu, config, theme, position }) => css`
	display: flex !important;
	cursor: pointer;
	min-height: 3em;
    //padding: 1em 0.85em;
    padding: 0.75em 1.25em;
	position: relative;
    font-weight: 500;
    &, span {
        transition: all 400ms ease-in-out;
    }
    
    &:hover,
    &.active {
        background: #F8F8F8;
        color: #21A73F;
        span {
            padding-left: 0.5em;
        }
    }
    &:not(:last-child) {
        border-bottom: 0.125em #F8F8F8 solid;
    } 
`)

const StyledMenuItemLabel = styled.div`
    display: flex;
    align-items: center;
    & ~ svg {
        width: 1.75em;
        height: 1.75em;
		margin-left: 0.75em;
        margin-right: -0.625em;
	}
    
    svg {
        width: 1.75em;
        height: 1.75em;
        margin-right: 1em;
        fill-opacity: 0.5;
    }
`;

const StyledMenuItemLink = styled.a<any>(({ config, theme }) => css`
	${Helpers.clamp('font-size', 0.9, 1, 1)};
    width: 100%;
    // font-size: 1em; // menuItem.textSize
	display: flex;
    align-items: center;
	text-decoration: none;
    justify-content: space-between;
    cursor: pointer;
    // line-height: 0.85; // Rubik - compensate additional height
    //line-height: 1.15; // Rubik - compensate additional height

	&,&:hover {
		color: currentColor;
	}
`)

const StyledNavigation = styled.nav<any>(({ config, theme }) => css`
    ${Helpers.clamp('width', 16.5, 20, 20)};  // navigationBar.categoryMenuItem.width
    min-height: 100%;
    height: max-content;
    //box-shadow: -0.5em 0.5em 1em #2b2d5910;
    padding-top: ${0.625}em; // navigationBar.borderRadius
	position: relative;
    &:before {
        content: '';
        position: absolute;
        
        top: -${0.625}em;
        z-index: -1;
        left: 0;
        background: #21A73F;
        height: ${0.625 * 2}em;
        width: 100%;
    }
    
    z-index: 10;
	overflow: hidden;
	background-color: #fff; // navigationBar.background
    // box-shadow: 0 0 1em rgba(0,0,0,.1);
    //border-style: solid;
    //border-width: 0.125em;
    //border-color: #21A73F;
    //border-right: none;
	//height: 15em; // navigationBar.height
	color: #2B2D59; // navigationBar.textColor
	font-weight: 600; // navigationBar.textWeight
`)